import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";

import { useTheme } from "@mui/styles";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useSocket } from "../../context/useSocket";
import { setStageSpikesAndComments } from "../../reducers/rtfoSlice";

export const RTFOEditComment = ({ stageData, editMode, setEditMode, selectedComment, setSelectedComment, editCommentVisible, setEditCommentVisible, darkMode, stageComments, setStageComments }) => {
  
  const dispatch = useDispatch();
  const { socket } = useSocket();

  const theme = useTheme();

  const [comment, setComment] = useState(selectedComment?.comment || "");
  const [channel, setChannel] = useState(selectedComment?.channel || "pressure");

  function handleCommentChange(e) {
    setComment(e.target.value);
  };

  return (
    <Dialog 
      open={editCommentVisible} 
      onClose={() => setEditCommentVisible(false)}
      maxWidth="sm"
      fullWidth={true}
      PaperProps={{
        style: {
          backgroundColor: theme?.palette?.elevationOne?.[darkMode ? 'dark' : 'light']
        },
        sx: {boxShadow: 1},
        elevation: 0
      }}
    >
      <DialogTitle>{editMode ? 'Edit' : 'View'} Comment</DialogTitle>
      <DialogContent>
        
        <Typography variant="h6">Channel</Typography>
        <ToggleButtonGroup 
          value={channel} 
          onChange={(e, val) => val && setChannel(val)}
          exclusive
          fullWidth
          disabled={!editMode}
        >
          <ToggleButton value="pressure" color={(darkMode ? "" : "primary")}>Pressure</ToggleButton>
          <ToggleButton value="rate" color={(darkMode ? "" : "primary")}>Rate</ToggleButton>
        </ToggleButtonGroup>

        <div style={{marginTop: 20, display: 'flex', flexDirection: 'column'}}>
          <Typography variant="h6">Date</Typography>
          <Typography>{new Date(selectedComment?.timestamp)?.toLocaleString()}</Typography>
        </div>

        <div style={{marginTop: 20, display: 'flex', flexDirection: 'column'}}>
          <Typography variant="h6">Value</Typography>
          <Typography>{selectedComment?.[channel]} {channel === 'pressure' ? 'MPa' : 'm3/min'}</Typography>
        </div>

        <div style={{marginTop: 20, display: 'flex', flexDirection: 'column'}}>
          <Typography variant="h6">Comment</Typography>
          <TextField
            // label="Comment"
            placeholder="New comment"
            multiline
            rows={4}
            style={{width: '100%', marginTop: 10}}
            value={comment}
            onChange={handleCommentChange}
          />
        </div>
        
      </DialogContent>
      <DialogActions style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>

        <Button onClick={handleDeleteComment} color={"secondary"} style={{marginRight: 10}}>
          Delete
        </Button>
        <div>
          <Button onClick={() => setEditCommentVisible(false)} color={darkMode ? "inherit" : "primary"} style={{marginRight: 10}}>
            Cancel
          </Button>
          <Button 
            onClick={handleSaveStage} 
            color={darkMode ? "inherit" : "primary"} 
            style={{color: darkMode ? '#000' : '#fff'}} 
            variant="contained"
            disabled={!comment || comment.length < 1 || comment === selectedComment?.comment}
          >
            Save
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );

  // FUNCTIONS
  function handleSaveStage() {
    try {
      let newStageComments = stageComments ? [...stageComments?.filter(comment => comment?.timestamp !== selectedComment?.timestamp)] : [];
      newStageComments.push({
        ...selectedComment,
        comment: comment?.trim(),
        channel
      });

      newStageComments.sort((a, b) => a.timestamp - b.timestamp);

      setStageComments(newStageComments);
      setSelectedComment(null);
      setEditCommentVisible(false);

      setEditMode(false);
      socket?.send(JSON.stringify({
        messageType: 'saveStage',
        stage: {...stageData, comments: newStageComments}
      }));

      dispatch(setStageSpikesAndComments({stageName: stageData?.name, stageSpikes: stageData?.spikes, stageComments: newStageComments}));

    } catch (error) {
      console.log(error);
      return;
    };
  };

  function handleDeleteComment() {
    try {
      // Delete comment
      const newStageComments = stageComments ? [...stageComments?.filter(comment => comment?.timestamp !== selectedComment?.timestamp)] : [];

      setStageComments(newStageComments);
      setSelectedComment(null);
      setEditCommentVisible(false);

      setEditMode(false);
      socket?.send(JSON.stringify({
        messageType: 'saveStage',
        stage: {...stageData, comments: newStageComments}
      }));

      dispatch(setStageSpikesAndComments({stageName: stageData?.name, stageSpikes: stageData?.spikes, stageComments: newStageComments}));
    } catch (error) {
      console.log(error);
      return;
    };
  };

};